import {defineNuxtRouteMiddleware} from '#imports';
import {safelyNavigateTo} from '@malt/utils';

export default defineNuxtRouteMiddleware((to) => {
    if (to.path.startsWith('/freelancer/income-summary')) {
        return safelyNavigateTo({path: '/taxes/freelancer/income-summary'}, {externalToThisApp: true});
    }
});
